// extracted by css-extract-rspack-plugin
export default {"banner":"FS6XVr1ThIwygHMb"};